class ratingController {
	$onInit() {
		if (!this.ratingSize) {
			this.ratingSize = 5;
		}
		if (!this.ratingSelected) {
			this.ratingSelected = 0;
		}
		this.createIcons();
	}
	/**
	 * In this part creating the array with the class for the itmes `i` 
	 * for paint the state of raitng 
	 */
	createIcons() {
		this.icons = [];
		for (let i = 0; i < this.ratingSize; i++) {
			if (i < this.ratingSelected) {
				this.icons.push(`fa fa-star rating__item__icon--active`);
			} else {
				this.icons.push(`fa fa-star`);
			}
		}
	}
	createIconsStyled() {
		this.icons = [];
		for (let i = 0; i < this.ratingSize; i++) {
			if (i < this.ratingSelected) {
				this.icons.push(`fa fa-star`);
			} else {
				this.icons.push(`fa fa-star rating__item__icon--active`);
			}
		}
	}

	returnIndex(index) {
		if (this.selectRating && angular.isFunction(this.selectRating)) {
			this.ratingSelected = index;
			// this.ratingSelected = this.ratingSize - index;
			this.createIconsStyled();
			this.selectRating({
				index
			});
		}
	}
}

export default ratingController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/rating/rating.contoller.js